<template>
    <div class="secondary-menu">
                                <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    components: {

    },
    methods: {
        // 滚动监听  滚动触发的效果写在这里
        // handleScroll() {
        //     var scrollTop =
        //         window.pageYOffset ||
        //         document.documentElement.scrollTop ||
        //         document.body.scrollTop;
        //     console.log(scrollTop, this.offsetTo);
        //     if (scrollTop >= this.offsetTop) {
        //         this.isFixed = true;
        //     } else {
        //         this.isFixed = false;
        //     }
        // }
    },
    beforeCreate: function() {
        //可以在这加个loading事件
        //console.group('beforeCreate 创建前状态===============》');
    },
    created: function() {
        //在这结束loading，还做一些初始化，实现函数自执行
        //console.group('created 创建完毕状态===============》');
    },
    beforeMount: function() {
        //console.group('beforeMount 挂载前状态===============》');
    },
    mounted: function() {
        //在这发起后端请求，拿回数据，配合路由钩子做一些事情
        //console.group('mounted 挂载结束状态===============》');
        // 设置bar浮动阈值为 #fixedBar 至页面顶部的距离
        // this.offsetTop = document.querySelector("#nav-fixed").offsetTop;
        // 开启滚动监听
        // window.addEventListener("scroll", this.handleScroll);
    },
    beforeUpdate: function() {
        //console.group('beforeUpdate 更新前状态===============》');
    },
    updated: function() {
        //console.group('updated 更新完成状态===============》');
    },
    beforeDestroy: function() {
        // 你确认删除XX吗？  当前组件已被删除，清空相关内容
        //console.group('beforeDestroy 销毁前状态===============》');
    },
    destroyed: function() {
        //console.group('destroyed 销毁完成状态===============》');
        // 离开页面 关闭监听 不然会报错
        //  window.removeEventListener("scroll", this.handleScroll);
    }
};
</script>


<style scoped>
.secondary-menu {
    height: 100%;
    overflow-y: auto;
    background-color: #f1f1f1;
}
</style>
